/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-15 14:10:47
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-21 16:55:44
 */

import { createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";
import { sendAsync } from "../../../app/applicationSlice";
import { RootThunkApi } from "../../../app/store";
import { EAFRegisterListParams, getEAFRegisterList, getEAFRegisterDetail, getEAFRegisterSubmit, getEAFRegisterExport, SubmitParams, getRemove, DetailParams } from "../../../services/EAFRegister";

// 列表
export const getEAFRegisterListAsync = createAsyncThunk<
  void,
  EAFRegisterListParams,
  RootThunkApi<void>
>('EAFRegister/getEAFRegisterListAsync', async (params, api) => {
  return sendAsync(getEAFRegisterList(params), api)
})

// 详情
export const getEAFRegisterDetailAsync = createAsyncThunk<void, DetailParams, RootThunkApi<void>>(
  'EAFRegister/getEAFRegisterDetailAsync',
  async (params, api) => {
    return sendAsync(getEAFRegisterDetail(params), api)
  }
)

// 保存编辑
export const getEAFRegisterSubmitAsync = createAsyncThunk<
  void,
  SubmitParams,
  RootThunkApi<void>
>(
  'EAFRegister/getEAFRegisterSubmitAsync',
  async (params, api) => {
    return sendAsync(getEAFRegisterSubmit(params), api)
  }
)


//导出
export const getEAFRegisterExportAsync = createAsyncThunk<
  void,
  EAFRegisterListParams,
  RootThunkApi
>('EAFRegister/getEAFRegisterExportAsync ', async (params, api) => {
  return sendAsync(getEAFRegisterExport(params), api)
})


// 删除
export const getRemoveAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'EAFRegister/getRemoveAsync',
  async (params, api) => {
    return sendAsync(getRemove(params), api)
  }
)
